<template>
    <div :class="$style.root">


        <div v-if="videoRecommendedlist.length>0" style="display: flex; flex-wrap: wrap; justify-content:left;">
            <div
                class="video-box"
                @click="goVideoDetail(item.media_id)"
                v-for="(item, index) in videoRecommendedlist"
                :key="index">
                <div class="video-img">
                    <img :src="baseUrl+item.programId+'/thumbnail.png'" @error="defImg()" />
                </div>
                <div class="video-title">{{ item.media_name }}</div>
                <div class="video-info">
                    <div class="time">
                        <a-icon type="like"  :style="{ fontSize: '16px', color: '#cdcdcd', backGround: '#cdcdcd' }" />  &nbsp;{{ item.like_count||0 }}
                        <a-icon :style="{ fontSize: '16px', color: '#cdcdcd', backGround: '#cdcdcd' ,marginLeft:'10px'}" type="video-camera" />&nbsp; &nbsp;{{ item.views||0 }}

                        <a-icon :style="{ fontSize: '16px', color: '#cdcdcd', backGround: '#cdcdcd' ,marginLeft:'10px'}" type="download" /> &nbsp; &nbsp;{{ item.downloads||0 }}
                        <a-divider type="vertical" />
                        <span v-if="item.pwd" style="top: 3px;position: relative">
                            <svg t="1616814594842" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2277" width="14" height="14"><path d="M802.032941 983.04H222.027294c-77.884235 0-143.119059-58.127059-158.418823-135.107765a29.033412 29.033412 0 0 1 28.672-33.490823c2.770824-1.084235 5.601882-1.084235 8.31247-1.084236a30.117647 30.117647 0 0 1 29.57553 24.636236c9.035294 45.477647 46.983529 79.088941 91.979294 79.088941h579.945411c52.826353 0 95.894588-46.501647 95.894589-103.725177v-319.247058c0-57.223529-43.068235-103.725176-95.894589-103.725177h-65.174588v-108.423529c0-133.240471-86.618353-216.064-226.063059-216.064-137.938824 0-223.593412 82.823529-223.593411 216.124235V390.324706H222.027294c-52.886588 0-95.954824 46.501647-95.954823 103.725176v192.813177a30.117647 30.117647 0 0 1-30.117647 30.117647H90.352941a30.117647 30.117647 0 0 1-30.117647-30.117647v-192.752941c0-93.244235 72.161882-169.200941 161.129412-169.622589v-42.465882C221.364706 113.362824 337.679059 0 510.795294 0c174.561882 0 291.900235 113.362824 291.900235 282.021647v42.465882c88.907294 0.361412 161.069176 76.318118 161.069177 169.622589v319.247058c0.060235 93.545412-72.523294 169.622588-161.731765 169.622589z" fill="#8a8a8a" p-id="2278"></path><path d="M470.076235 533.865412a30.117647 30.117647 0 0 0-30.117647 30.117647v87.762823c0 10.962824 8.914824 19.877647 19.877647 19.877647h0.060236a19.877647 19.877647 0 0 1 19.877647 19.877647v83.606589a30.117647 30.117647 0 0 0 30.117647 30.117647h2.770823a30.117647 30.117647 0 0 0 30.117647-30.117647v-83.546353c0-11.023059 8.914824-19.937882 19.937883-19.937883a19.937882 19.937882 0 0 0 19.998117-19.937882V563.983059a30.117647 30.117647 0 0 0-30.117647-30.117647h-82.522353zM254.313412 324.668235h536.937412v65.295059H254.313412V324.608z" fill="#8a8a8a" p-id="2279"></path></svg>
                        </span>

                    </div>
                    <div class="play">{{ item.view_duration }}</div>
                </div>
            </div>
        </div>
        <div style="text-align:center; line-height:100px;" v-else>暂无内容</div>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import moment from 'moment';

    export default {
        name: 'NewVideoView',

        filters: {
            newformatTime(data) {
                const hours = moment.duration(parseInt(data, 0)).hours();

                const seconds = moment.duration(parseInt(data, 0)).seconds();

                const minutes = moment.duration(parseInt(data, 0)).minutes();

                return `${hours < 10 ? `0${hours}` : hours}:${minutes < 10 ? `0${minutes}` : minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
            },
        },
        props: {
            videoRecommendedlist: {
                type: Array,
                default: () => [],
            },
        },
        data() {
            return {
                spinning: false,
                delayTime: 500,
                baseUrl: '',
                errorImg01: 'http://221.226.156.108:8090/file/file/getPhoto.action?type=3&id=1',
                defaultImg: require('@/assets/LOGO_bg.png'),
            };
        },
        computed: {
            ...mapState('indexView', ['indexVideoLoading']),
        },
        watch: {
            $route() {
                this.$router.go(0);
            },
        },
        mounted() {
            const URL = `http://${document.domain}:8000/`;

         
            this.baseUrl = URL;
        },
        methods: {
            ...mapActions('params', [
                'storageLiveParams',
            ]),
            goVideoDetail(mediaId) {
                this.storageLiveParams({ mediaId });
                this.$router.push({ name: 'VideoDetailView', params: { mediaId } });
            },
            defImg() {
                const img = event.srcElement;
                img.src = this.defaultImg;
                img.onerror = null; // 防止闪图
            },
        },
    };
</script>

<style lang="less" module>
    .root {
        :global {
            .video-box {
                width: 280px;
                margin: 0 10px 20px;
                //   margin-right: 20px;
                //   margin-bottom: 20px;
                height: 230px;
                float: left;
                cursor: pointer;
            }

            .video-box:hover {
                background: #f0f3f9;
                -moz-box-shadow: 0 0 10px #888; /* 老的 Firefox */
                box-shadow: 0 0 10px #888;
            }

            .video-box:hover .video-title {
                width: 260px;
                // margin: 10px 10px 0;
            }


            .video-img {
                width: 100%;
                height: 158px;
                overflow: hidden;
            }

            .video-img img {
                transition: all 0.6s;
                width: 100%;
                height: 158px;
            }

            .video-box:hover .video-img img {
                transform: scale(1.2);
            }

            .video-title {
                width: 260px;
                height: 30px;
                line-height: 30px;
                margin-top: 10px;
                margin-left: 10px;
                overflow: hidden;
                text-overflow: ellipsis;
                -o-text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }
</style>
